import { onMounted, onUnmounted, ref } from "vue";

export function useProgressBar(containerRef: Ref<HTMLElement | null>) {
    const progressBarWidth = ref<string>("0%");

    let scrollableElement: HTMLElement | null = null;
    let progressBar: HTMLElement | null = null;
    let scrollableWidth = 0;
    let resizeObserver: ResizeObserver | null = null;

    function updateScrollableWidth() {
        if (scrollableElement) {
            scrollableWidth = scrollableElement.scrollWidth - scrollableElement.clientWidth;
        }
    }

    function updateProgress() {
        if (!scrollableElement || !progressBar) return;

        if (scrollableWidth <= 0) {
            progressBarWidth.value = "0%";
            return;
        }

        const scrolled = scrollableElement.scrollLeft;
        const progress = (scrolled / scrollableWidth) * 100;
        progressBar.style.width = `${progress}%`;
    }

    function handleScroll() {
        updateProgress();
    }

    function init() {
        if (!containerRef.value) return;

        // Dynamically find elements based on structure (without modifying HTML)
        scrollableElement = containerRef.value.querySelector('[class*="overflow-x-scroll"]') as HTMLElement | null;
        progressBar = containerRef.value.querySelector('[class*="progress-bar-inner"]') as HTMLElement | null;

        if (!scrollableElement || !progressBar) return;

        updateScrollableWidth();
        updateProgress();

        scrollableElement.addEventListener("scroll", handleScroll);

        resizeObserver = new ResizeObserver(() => {
            updateScrollableWidth();
            updateProgress();
        });

        resizeObserver.observe(containerRef.value);
    }

    onMounted(() => {
        init();
    });

    onUnmounted(() => {
        if (scrollableElement) {
            scrollableElement.removeEventListener("scroll", handleScroll);
        }
        if (resizeObserver) {
            resizeObserver.disconnect();
        }
    });

    return {
        progressBarWidth,
    };
}
